function CenteredMessage({
  title = 'Ocurrió un error',
  message,
  icon = '⚠️'
}) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.icon}>{icon}</div>
        <h2 style={styles.title}>{title}</h2>
        {message && <p style={styles.message}>{message}</p>}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '3rem 2rem'
  },
  card: {
    textAlign: 'center',
    padding: '2rem 2.5rem',
    borderRadius: '14px',
    background: '#fff',
    border: '1px solid #e5e7eb',
    boxShadow: '6px 10px 24px rgba(0,0,0,0.08)',
    maxWidth: '420px'
  },
  icon: {
    fontSize: '2rem',
    marginBottom: '0.5rem'
  },
  title: {
    fontSize: '1.25rem',
    marginBottom: '0.4rem',
    color: '#111827'
  },
  message: {
    fontSize: '0.95rem',
    color: '#6b7280'
  }
};

export default CenteredMessage;
